if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();
      this.viewport = this;
      
      this.init = this.init.bind(this);
      this.pause = this.pause.bind(this);
      this.resume = this.resume.bind(this);
      
      this.resizeObserver = new ResizeObserver(() => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.init, 100);
      });
    }

    connectedCallback() {
      this.track = this.querySelector('.testimonial__track');
      this.originalGroup = this.querySelector('.testimonial__group');

      if (!this.viewport || !this.track || !this.originalGroup) return;

      this.init();
      this.resizeObserver.observe(this.viewport);
      
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
      
      this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.init);
      }
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.resume);
      if (this.mediaQuery && this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.init);
      }
    }

    init() {
      if (this.mediaQuery && this.mediaQuery.matches) {
        this.track.style.animation = 'none';
        return;
      }

      // Remove existing clones
      const clones = this.track.querySelectorAll('.testimonial__group--clone');
      clones.forEach(clone => clone.remove());

      this.track.style.animation = 'none';
      this.track.style.transform = 'translateX(0)';

      const groupWidth = this.originalGroup.offsetWidth;
      const viewportWidth = this.viewport.offsetWidth;
      
      if (groupWidth === 0) return;

      const clonesNeeded = Math.ceil(viewportWidth / groupWidth);
      
      for (let i = 0; i < clonesNeeded; i++) {
        const clone = this.originalGroup.cloneNode(true);
        clone.classList.add('testimonial__group--clone');
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      const speed = 50; // pixels per second
      const duration = groupWidth / speed;
      
      this.track.style.setProperty('--marquee-duration', `${duration}s`);
      this.track.style.setProperty('--marquee-shift', `-${groupWidth}px`);
      
      void this.track.offsetWidth; // Force reflow
      this.track.style.animation = 'testimonial-marquee var(--marquee-duration) linear infinite';
    }

    pause() {
      if (window.innerWidth >= 992 && (!this.mediaQuery || !this.mediaQuery.matches)) {
        this.track.style.animationPlayState = 'paused';
      }
    }

    resume() {
      if (!this.mediaQuery || !this.mediaQuery.matches) {
        this.track.style.animationPlayState = 'running';
      }
    }
  }

  customElements.define('testimonial-slider', TestimonialSlider);
}
